import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, MenuItem, Menu, ListItemIcon, ListItemText, Dialog, DialogTitle, IconButton} from '@material-ui/core';
import Button from '@components/common/button/Button';
import CloseIcon from '@material-ui/icons/Close';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import NameIcon from '@material-ui/icons/TextFields';
import ActivateIcon from '@material-ui/icons/EventAvailable';
import InactivateIcon from '@material-ui/icons/Clear';
import HiddenIcon from '@material-ui/icons/Visibility';
import ShareIcon from '@material-ui/icons/VisibilityOff';
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import HistoryIcon from '@material-ui/icons/History';
import SchoolIcon from '@material-ui/icons/School';
import CheckIcon from '@material-ui/icons/Check';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import WarningIcon from '@material-ui/icons/WarningRounded';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import { ISuggestion, ICreateSuggestion, IScheduleChange } from '@app-types/websocket/suggestion.types';
import { SUGGESTION_TYPES, SUGGESTION_CHANGE_TYPES } from '@constants/suggestionTypes';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { ISchedule, IScheduleSchool } from '@app-types/websocket/schedule.types';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import { FamilyMemberType } from '@services/family/family.constants';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import SCHOOL_TYPES from '@constants/schoolTypes';
import * as UserActions from '@services/user/user.actions';
import { getOnlyWeeksOf } from '@services/user/user.utils';
import * as SuggestionActions from '@services/suggestion/suggestion.action';
import * as ScheduleActions from '@services/schedule/schedule.action';
import { grayColor, secondaryColor, styleColors } from 'src/main.style';
import { DialogTop } from '@components/economy/DialogComponens';
import SuggestionItem from './SuggestionItem';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  showSuggestionHistory:boolean;
  showSchoolSetting:boolean;
  showScheduleSettingsMenu:boolean;
  subMenuRef:HTMLDivElement|null;
  confirmDeleteScheduleId: number | null,
  confirmOnlyMyWeeks: boolean,
}

interface IProps extends WithStyles<typeof HeaderStyle> {

  numSentSuggestions?:number;
  numReceivedSuggestions?:number;

  suggestions:ISuggestion[];
  userId:number;
  family:IFamilyMember[];
  schedule:ISchedule;
  calendarSettings: ICalendarSetting;
  onlyWeeksOf: number | undefined;
  usedByErrorSchedules:number[];
  myRole:FamilyMemberType;
  isEditing:boolean;
  

  close:() => void;
  startEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  startGuide:(scheduleId:number) => void;
  suggestEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  createSuggestion: (data: ICreateSuggestion) => void;
  loadSuggestionHistory: (scheduleId:number) => void;
  changeScheduleSchool: (data: IScheduleSchool) => void;
  changeName:(scheduleId:number, scheduleName:string) => void;
  updateCalendarSettings: (data: ICalendarSetting) => void;
  setOnlyWeeksOf: (parentId:number) => void;
  showDetails:(suggestion:ISuggestion) => void;
}

class ScheduleItem extends React.Component<IProps, IState> {

  private oldSuggestionRef: React.RefObject<HTMLDivElement> = React.createRef();
  private schoolSettingRef: React.RefObject<HTMLDivElement> = React.createRef();
  private scheduleActionsRef: React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
      showScheduleSettingsMenu:false,
      showSuggestionHistory:false,
      showSchoolSetting:false,
      subMenuRef:null,
      confirmDeleteScheduleId: null,
      confirmOnlyMyWeeks: false,
    };
  }



  public render() {
    const {classes, suggestions, userId, schedule, myRole, family, startEditing, close} = this.props;

    const highlightSchedule = this.props.usedByErrorSchedules.includes(schedule.id);

    const suggestionsAwaitingReply:JSX.Element[] = [];
    const suggestionHistory:JSX.Element[] = [];

    const usedBy:number[] = [];
    for (const mem of family) {
      if ((mem.role === FamilyMemberType.PARENT || mem.role === FamilyMemberType.CHILD || mem.id === this.props.userId) 
        && mem.calendars && mem.calendars.includes(schedule.id)) {
        usedBy.push(mem.id);
      }
    }

    const scheduleRender:JSX.Element = this.renderScheduleItem(schedule, this.props.numSentSuggestions, 
      this.props.numReceivedSuggestions, highlightSchedule, usedBy);

    
    const activateRender:JSX.Element = this.renderActivateMenuItem(schedule, highlightSchedule );
    const changeNameRender:JSX.Element = this.renderChangeNameMenuItem(schedule);      

    // let editRender:JSX.Element|null = null;
    let editGuideRender:JSX.Element|null = null;
    let eraseRender:JSX.Element|null = null;
    let showHistoryRender:JSX.Element|null = null;
    let schoolSettingRender:JSX.Element|null = null;


    if (myRole === FamilyMemberType.PARENT) {

      // editRender = this.renderEditScheduleMenuItem(schedule, myRole);
      editGuideRender = this.renderGuidedEditScheduleMenuItem(schedule, myRole);
      eraseRender = this.renderEraseScheduleMenuItem(schedule.id);
      showHistoryRender = this.renderShowHistory();
      schoolSettingRender = this.renderSchoolSetting();

      if (this.state.showSuggestionHistory) {
        const suggestionHistoryList = suggestions.filter((sugg) =>(
          sugg.schedules.includes(schedule.id)
          && ((sugg.status === SUGGESTION_TYPES.ACCEPTED_AND_EXECUTED && sugg.responseAccountId !== 0)
            || sugg.status === SUGGESTION_TYPES.DELETED
            || sugg.status === SUGGESTION_TYPES.REJECTED))).sort((a,b) => b.responseTime - a.responseTime);

        for (const sugg of suggestionHistoryList) {
          suggestionHistory.push(<SuggestionItem suggestion={sugg} userId={userId} family={family} 
            showDetails={(suggestion:ISuggestion) => {this.props.showDetails(suggestion)}}
            close={() => this.close()} startEditing={startEditing} key={""+sugg.id} />);
        }
      }
      if (suggestionHistory.length === 0) {
        suggestionHistory.push(<div key={"empty"} style={{padding: '0px 40px', color: 'gray'}}>{tn.lang.empty}</div>)
      }

      for (const sugg of suggestions) {
        if (sugg.status === SUGGESTION_TYPES.AWAITING_APPROVAL && sugg.schedules.includes(schedule.id)) {
          if (sugg.schedules.includes(schedule.id)) {
            if (sugg.creatorId === userId) {
              suggestionsAwaitingReply.push(<SuggestionItem suggestion={sugg} userId={userId} family={family} 
                showDetails={(suggestion:ISuggestion) => {this.props.showDetails(suggestion)}}
                close={() => this.close()} startEditing={startEditing} key={""+sugg.id} />);
            } else {
              suggestionsAwaitingReply.push(<SuggestionItem suggestion={sugg} userId={userId} family={family} 
                showDetails={(suggestion:ISuggestion) => {this.props.showDetails(suggestion)}}
                close={() => this.close()} startEditing={startEditing} key={""+sugg.id} />);
            }
          }
        }
      }
    }

    return (
      <>
      
        {scheduleRender}
        <Menu // suggestionHistory
          anchorEl={this.oldSuggestionRef.current}
          getContentAnchorEl={null}
          open={this.state.showSuggestionHistory}
          anchorReference="anchorEl"
          onClose={() => this.setState({showSuggestionHistory:false})}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}
          classes={{
            paper: classes.menuPaper,
            list: classes.menuList,
          }}
        >
          {suggestionHistory}
        </Menu>
        <Menu // school handover place setting
          anchorEl={this.schoolSettingRef.current}
          getContentAnchorEl={null}
          open={this.state.showSchoolSetting}
          anchorReference="anchorEl"
          onClose={() => this.setState({showSchoolSetting:false})}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}
          classes={{
            paper: classes.menuPaper,
            list: classes.menuList,
          }}
        >
          {this.renderSchoolOptions()}
        </Menu>
        <Menu // actions menu
          anchorEl={this.scheduleActionsRef.current}
          getContentAnchorEl={null}
          open={this.state.showScheduleSettingsMenu}
          anchorReference="anchorEl"
          onClose={() => this.setState({showScheduleSettingsMenu:false})}
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          transformOrigin={{vertical: 'top', horizontal: 'center'}}
          classes={{
            paper: classes.menuPaper,
            list: classes.menuList,
          }}
        >
          {/* editRender */}
          {editGuideRender}
          {suggestionsAwaitingReply}
          {showHistoryRender}
          {schoolSettingRender}
          {changeNameRender}
          {activateRender}
          {eraseRender}
        </Menu>

        
        <Dialog  
          open={this.state.confirmDeleteScheduleId !== null}
          onClose={() => this.setState({ confirmDeleteScheduleId: null })}
        >
          <DialogTop>
            <DialogTitle>{tn.lang.calDeleteSchedules}</DialogTitle>
            <IconButton onClick={() => this.setState({ confirmDeleteScheduleId: null })}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <div style={{ padding: '8px 24px',alignItems: "center", display: 'flex', flexDirection: 'column' }}>
            {tn.lang.calConfirmReply}
          </div>


          <div style={{display: "flex", flexDirection: "column", margin: "8px 24px", padding: "8px 24px", gap: "10px"}}>

          <Button variant='contained'
              classes={{ contained: classes.buttonContained }}
              color='primary'
              onClick={() => {
                if (this.state.confirmDeleteScheduleId !== null) {
                  this.deleteSchedule(this.state.confirmDeleteScheduleId);
                  this.close();
                }
                this.setState({ confirmDeleteScheduleId: null });
              }}
            >
              <div style={{width: "60px", margin: "4px"}}>
              {tn.lang.delete}
              </div>
            </Button>
            <Button
              variant='outlined'
              classes={{ outlined: classes.buttonOutlined }}
              onClick={() => this.setState({ confirmDeleteScheduleId: null })}
            >
              <div style={{width: "60px", margin: "4px"}}>
              {tn.lang.cancel}
              </div>
            </Button>

          </div>
        </Dialog>

        <Dialog
          open={this.state.confirmOnlyMyWeeks}
          onClose={() => { this.setState({ confirmOnlyMyWeeks: false }); this.close(); }}
        >
          <DialogTop>
            <DialogTitle>{tn.lang.scheduleShowOnlyMyWeeks}</DialogTitle>
            <IconButton onClick={() => { this.setState({ confirmOnlyMyWeeks: false }); this.close(); }}>
              <CloseIcon />
            </IconButton>
          </DialogTop>
          <div style={{ padding: '8px 24px', alignItems: "center", display: 'flex', flexDirection: 'column' }}>
            {tn.lang.scheduleShowOnlyMyWeeksQuestion}
          </div>

          <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "8px 24px", padding: "8px 24px", gap: "10px" }}>
            <Button
              variant='outlined'
              classes={{ outlined: classes.buttonOutlined }}
              onClick={() => {
                this.setState({ confirmOnlyMyWeeks: false });
                this.close();
              }}
            >
              <div style={{ width: "60px", margin: "4px" }}>
                {tn.lang.no}
              </div>
            </Button>
            <Button variant='contained'
              classes={{ contained: classes.buttonContained }}
              color='primary'
              onClick={() => {
                this.props.setOnlyWeeksOf(this.props.userId);
                this.setState({ confirmOnlyMyWeeks: false });
                this.close();
              }}
            >
              <div style={{ width: "60px", margin: "4px" }}>
                {tn.lang.yes}
              </div>
            </Button>
          </div>
        </Dialog>

    </>);
  }

  private renderShowHistory() {
    return (<MenuItem
      key = {"showoldsugg"+this.props.schedule.id}
      className={this.props.classes.menuListItem}
      onClick={() => this.toggleSuggestionHistory()}>
      <ListItemIcon>
        <HistoryIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>
        <span style={{display: 'flex', alignItems: 'center'}}>
          {tn.lang.calOldSuggestions}
        </span>
      </ListItemText>
      <div className={this.props.classes.menuItemEnd} ref={this.oldSuggestionRef}>
        <ArrowRightIcon />
      </div>
    </MenuItem>);
  }

  private renderSchoolSetting() {
    return (<MenuItem
      key = {"schoolsetting"+this.props.schedule.id}
      className={this.props.classes.menuListItem}
      onClick={() => this.setState({showSchoolSetting:!this.state.showSchoolSetting})}>
      <ListItemIcon>
        <SchoolIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>
        <span style={{display: 'flex', alignItems: 'center'}}>
          {tn.lang.calSchoolSetting}
        </span>
      </ListItemText>
      <div className={this.props.classes.menuItemEnd} ref={this.schoolSettingRef}>
        <ArrowRightIcon />
      </div>
    </MenuItem>);
  }

  private renderSchoolOptions() {
    const {classes, schedule} = this.props;
    const selectedSchool = schedule.school ? schedule.school : SCHOOL_TYPES.CALCULATED_ON_AGE;
    const options:Array<{type:SCHOOL_TYPES, label:string}> = [
      {type: SCHOOL_TYPES.CALCULATED_ON_AGE, label: tn.lang.calSchoolCalculatedOnAge},
      {type: SCHOOL_TYPES.PRESCHOOL, label: tn.lang.calSchoolPreschool},
      {type: SCHOOL_TYPES.SCHOOL, label: tn.lang.calSchoolSchool},
    ];

    return options.map((option) => (
      <MenuItem className={classes.menuListItem} key={"school"+option.type+schedule.id}
        onClick={() => this.selectSchool(option.type)}>
        <ListItemIcon>
          {option.type === selectedSchool ? <CheckIcon fontSize="small" /> : <span />}
        </ListItemIcon>
        <div className={classes.menuItemTitle}>{option.label}</div>
      </MenuItem>
    ));
  }

  private renderChangeNameMenuItem(schedule:ISchedule) {
    const {classes} = this.props;

    return(
      <MenuItem className={classes.menuListItem} key={"rename"+schedule.id} disabled={false}
        onClick={() => {
          this.props.changeName(schedule.id, (schedule.name?schedule.name:tn.lang.scheduleNameNew(schedule)));
          this.close();
        }}>
        <ListItemIcon>
          <NameIcon />
        </ListItemIcon>
        <div>
          <div className={classes.menuItemTitle}>{tn.lang.renameSchedule}</div>
        </div>
      </MenuItem>);
  }

  private renderEraseScheduleMenuItem(scheduleId:number) {
    const {classes, suggestions} = this.props;

    for (const sugg of suggestions){
      if (sugg.status === SUGGESTION_TYPES.AWAITING_APPROVAL && sugg.schedules.includes(scheduleId) 
        && sugg.changes.length === 1 && sugg.changes[0].type === SUGGESTION_CHANGE_TYPES.DELETE_SCHEDULE) {
        return null;
      }
    }
    return(
      <MenuItem className={classes.menuListItem} key={"erase"+scheduleId} disabled={this.props.isEditing}
        onClick={() => {
          // this.deleteSchedule(scheduleId);
          this.setState({confirmDeleteScheduleId: scheduleId});
         // this.close();
        }}>
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        <div>
          <div className={classes.menuItemTitle}>{tn.lang.calDeleteSchedules}</div>
        </div>
      </MenuItem>);
      
  }

  private renderActivateMenuItem(schedule:ISchedule|undefined, highLight:boolean) {
    const {classes} = this.props;
    let yellowBlob = highLight;
    let disabled = true;
    let text:string = tn.lang.calMustBeShared;
    let icon = <EditIcon />;
    let action:() => void = () => {console.log("not implemented");}
    if (schedule) {
      disabled = false;
      if (schedule.status === SCHEDULE_TYPES.DELETED || schedule.status === SCHEDULE_TYPES.DELETED_WIP) {
        text = tn.lang.calMakeInactive;
        action = () => {this.inactivateSchedule(schedule.id); this.close();}
        icon = <InactivateIcon />;
      } else if (schedule.status === SCHEDULE_TYPES.WIP) {
        text = tn.lang.calShareSchedule;
        action = () => {this.shareSchedule(schedule.id); this.close();}
        icon = <ShareIcon />;
      } else if (schedule.status === SCHEDULE_TYPES.SHARED || schedule.status === SCHEDULE_TYPES.ACTIVE) {
        if (this.props.calendarSettings.calendars !== undefined && !this.props.calendarSettings.calendars.includes(schedule.id)) {
          text = tn.lang.calMakeActive;
          action = () => {this.activateSchedule(schedule.id);}
          icon = <ActivateIcon />;
        } else {
          text = tn.lang.calMakeInactive;
          action = () => {this.inactivateSchedule(schedule.id); this.close();}
          icon = <InactivateIcon />;
          yellowBlob = false;
        }
        
      }
    }


    return(
      <MenuItem className={classes.menuListItem} key={"activate"+schedule?.id} disabled={disabled} onClick={action}>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <div style={{display: 'flex'}}>
          <div className={classes.menuItemTitle}>{text}</div>
          {yellowBlob
                ?<span style={{backgroundColor:styleColors.handoverYellow}} className={this.props.classes.suggestionBadge} />
                :null}
        </div>
      </MenuItem>);
  }

  private renderEditScheduleMenuItem(schedule:ISchedule, myRole:FamilyMemberType) {
    const {classes} = this.props;
    let disabled = false;
    const icon = <EditIcon />;
    if (schedule.status === SCHEDULE_TYPES.DELETED || schedule.status === SCHEDULE_TYPES.DELETED_WIP) {
      disabled = true;
    }

    if (myRole !== FamilyMemberType.PARENT || this.props.isEditing) {
      disabled = true;
    } 

    return(
      <MenuItem className={classes.menuListItem} key={"editSchedule"+schedule.id} disabled={disabled}
        onClick={() => {
          let pendingChange = 0;

          for (const sugg of this.props.suggestions) {
            if (sugg.status === SUGGESTION_TYPES.AWAITING_APPROVAL && sugg.schedules.includes(schedule.id)) {
              pendingChange = sugg.id;
              break;
            }
          }

          if (pendingChange > 0) {
            this.props.suggestEditing(schedule.id,pendingChange);
          } else {
            this.props.startEditing(schedule.id, 0);
          }
          
          this.close();
        }}>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <div className={classes.menuItemTitle} style={{fontSize: '16px'}}>{tn.lang.calMakeSuggestion}</div>
      </MenuItem>);
  }

  private renderGuidedEditScheduleMenuItem(schedule:ISchedule, myRole:FamilyMemberType) {
    const {classes} = this.props;
    let disabled = false;
    const icon = <EditIcon />;
    if (schedule.status === SCHEDULE_TYPES.DELETED || schedule.status === SCHEDULE_TYPES.DELETED_WIP) {
      disabled = true;
    }

    if (myRole !== FamilyMemberType.PARENT || this.props.isEditing) {
      disabled = true;
    } 

    return(
      <MenuItem className={classes.menuListItem} key={"guideSchedule"+schedule.id} disabled={disabled}
        onClick={() => {
          this.props.startEditing(schedule.id, 0);
          // this.props.startGuide(schedule.id);
          this.close();
        }}>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
          <div className={classes.menuItemTitle} style={{ fontSize: '16px'}}>{tn.lang.calMakeSuggestionGuide}</div>
      </MenuItem>);
  }

  private renderScheduleItem(schedule:ISchedule, sentSuggestions:number|undefined, receivedSuggestions:number|undefined, 
    usedByError:boolean, usedBy:number[]) {

    const sent = sentSuggestions?sentSuggestions:0;
    const received = receivedSuggestions?receivedSuggestions:0;
    const {classes, family} = this.props;
    let titleStyle = 'none';


    let icon = <CalendarIcon />;
    let subMenu:string = "";
    if (usedByError) {
      icon = <WarningIcon style={{fill:'#FFA800'}} />;
      if (usedBy.length === 0) {
        subMenu = tn.lang.newCalendar;
      }
    } else if (schedule.status === SCHEDULE_TYPES.WIP) {
      icon = <HiddenIcon />;
      subMenu = tn.lang.headerScheduleVisibleForYou;
    } else if (usedBy.includes(this.props.userId)) {
      icon = <ActivateIcon />;
    }
    if (usedBy.length !== 0) {
      subMenu = subMenu + tn.lang.selectedAsActiveBy(tn.familyMemberNames(usedBy,family));
      if (usedByError) {
        const notUsedBy:number[] = [];
        for (const mem of family) {
          if (mem.role === FamilyMemberType.PARENT && !usedBy.includes(mem.id)) {
            notUsedBy.push(mem.id);
          }
        }
        if (notUsedBy.length > 0) {
          subMenu = subMenu + tn.lang.selectedAsActiveByExluding(tn.familyMemberNames(notUsedBy,family));
        }
      }
    }
    if (schedule.status === SCHEDULE_TYPES.DELETED || schedule.status === SCHEDULE_TYPES.DELETED_WIP) {
      titleStyle = 'line-through';
    }

    return (
      <MenuItem className={classes.menuListItem} key={schedule.id} 
        onClick={() => this.setState({showScheduleSettingsMenu:!this.state.showScheduleSettingsMenu})}>
        <ListItemIcon>
          {icon}
        </ListItemIcon>
        <div>
          <div className={classes.menuItemTitle} style={{ fontSize: '16px' }}>
            <span style={{ textDecoration: titleStyle}}>{tn.lang.scheduleNameNew(schedule)}</span>
            <div  style={{display: 'flex', alignItems: 'center', marginLeft:'3px'}}>
              <span style={{backgroundColor:grayColor}} className={classes.suggestionBadge
                +(sent < 1 ?(" "+classes.hiddenBadge):"")}>
                  {sent}
              </span>
              <span style={{backgroundColor:secondaryColor}} className={classes.suggestionBadge
                +(received < 1 ?(" "+classes.hiddenBadge):"")}>
                  {received}
              </span>
              {usedByError
                ?<span style={{backgroundColor:styleColors.handoverYellow}} className={this.props.classes.suggestionBadge} />
                :null}
            </div>
          </div>
          {subMenu && <div className={classes.menuItemTime} style={usedByError?{textShadow: '0 0 10px #FFA800'}:{}}>
            {subMenu}</div>}
        </div>
        <div className={classes.menuItemEnd} ref={this.scheduleActionsRef}>
          <ArrowRightIcon />
        </div>
      </MenuItem>);
  }


  

  private close() {
    this.setState({showSuggestionHistory:false, showSchoolSetting:false, showScheduleSettingsMenu:false});
    this.props.close();
  }

  private selectSchool(school:SCHOOL_TYPES) {
    const selectedSchool = this.props.schedule.school ? this.props.schedule.school : SCHOOL_TYPES.CALCULATED_ON_AGE;
    if (school !== selectedSchool) {
      // The submenu stays open, so the checkmark moves when the SCHEDULE_UPDATE
      // broadcast comes back with the new setting.
      this.props.changeScheduleSchool({scheduleId: this.props.schedule.id, school});
    }
  }

  private toggleSuggestionHistory() {
    if (!this.state.showSuggestionHistory) {
      // The login snapshot only carries the last 60 days of suggestions, so ask the
      // backend for the schedule's complete history when the list is opened.
      this.props.loadSuggestionHistory(this.props.schedule.id);
    }
    this.setState({showSuggestionHistory:!this.state.showSuggestionHistory});
  }

  private activateSchedule(scheduleId:number,) {
    const calSettings = this.props.calendarSettings;
    if (calSettings) {
      const settingsCopy:ICalendarSetting = JSON.parse(JSON.stringify(calSettings));
      if (settingsCopy.calendars !== undefined && !settingsCopy.calendars.includes(scheduleId)) {
        // Was at least one schedule already active before this one?
        const hadActiveSchedule = settingsCopy.calendars.length > 0;
        settingsCopy.calendars.push(scheduleId);
        this.props.updateCalendarSettings(settingsCopy);
        if (hadActiveSchedule && this.props.onlyWeeksOf === undefined && this.props.myRole === FamilyMemberType.PARENT) {
          // A parent activating a second schedule while showing all weeks — offer to only
          // show their own weeks to keep the combined calendar readable. Leave the menu
          // open behind the dialog. Skip the prompt if it's already enabled.
          this.setState({ confirmOnlyMyWeeks: true });
          return;
        }
      } else {
        this.props.updateCalendarSettings(settingsCopy);
      }
    }
    this.close();
  }
  
  private inactivateSchedule(scheduleId:number,) {
    const calSettings = this.props.calendarSettings;
    if (calSettings) {
      const settingsCopy:ICalendarSetting = JSON.parse(JSON.stringify(calSettings));
      if (settingsCopy.calendars !== undefined && settingsCopy.calendars.includes(scheduleId)) {
        settingsCopy.calendars = settingsCopy.calendars.filter((sId) => sId !== scheduleId);
      }
      this.props.updateCalendarSettings(settingsCopy);
    }
  }

  private shareSchedule(scheduleId:number) {
    const mods:IScheduleChange[] = [];
    mods.push({
      scheduleId,
      type: SUGGESTION_CHANGE_TYPES.SHARE,
      isParentA: true,
      newScheduleEntry: undefined,
      oldScheduleEntry: undefined,
      children:undefined
    });

    const data: ICreateSuggestion = {
      changes: mods,
    };

    this.props.createSuggestion(data);
  }

  private deleteSchedule(scheduleId:number) {
    const mods:IScheduleChange[] = [];
    mods.push({
      scheduleId,
      type: SUGGESTION_CHANGE_TYPES.DELETE_SCHEDULE,
      isParentA: true,
      newScheduleEntry: undefined,
      oldScheduleEntry: undefined,
      children:undefined
    });

    const data: ICreateSuggestion = {
      changes: mods,
    };

    this.props.createSuggestion(data);
    
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  const suggestions:ISuggestion[] = state.suggestion.suggestions?state.suggestion.suggestions:[];
  const calendarSettings: ICalendarSetting = state.user.calendarSettings;


  return {
    userId,
    suggestions,
    family: state.family.family,
    calendarSettings,
    onlyWeeksOf: getOnlyWeeksOf(state),
  };
}


const mapDispatchToProps = {
  updateCalendarSettings:UserActions.updateCalendarSettings,
  setOnlyWeeksOf: UserActions.setOnlyWeeksOf,
  createSuggestion: SuggestionActions.createSuggestion,
  loadSuggestionHistory: SuggestionActions.loadSuggestionHistory,
  changeScheduleSchool: ScheduleActions.changeScheduleSchool,
};

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(HeaderStyle)(ScheduleItem));



// WEBPACK FOOTER //
// ./src/components/calendar2/header/ScheduleItem.tsx